/* Odd Muse collection pagination (Option 2: prominent next page)
 *
 * Progressive enhancement only. Without this script, Next and Previous are
 * ordinary links and the page select stays hidden.
 *
 * - Reveals the "Go to page" select and navigates on change, keeping any
 *   active filters and sort order in the URL.
 * - On mobile, shows a small "Page 3 of 26" pill once the shopper has
 *   scrolled into the grid, and hides it again when the pagination itself
 *   is on screen.
 *
 * Built as a custom element so it re-initialises by itself when facets.js
 * swaps in a new product grid after a filter or sort change.
 */
(function () {
  if (customElements.get('om-pagination')) return;

  var MOBILE_QUERY = '(max-width: 989px)';
  var SCROLLED_INTO_GRID = 240; // px of grid scrolled past before the pill appears

  class OmPagination extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('.om-pg__nav');
      this.pill = this.querySelector('.om-pg__pill');
      this.jump = this.querySelector('.om-pg__jump');
      this.select = this.jump ? this.jump.querySelector('select') : null;
      this.grid =
        document.getElementById('ProductGridContainer') ||
        this.closest('.collection') ||
        this.parentElement;

      this.handleChange = this.handleChange.bind(this);
      this.requestPillUpdate = this.requestPillUpdate.bind(this);
      this.updatePill = this.updatePill.bind(this);
      this.ticking = false;

      if (this.jump && this.select) {
        this.jump.hidden = false;
        this.select.addEventListener('change', this.handleChange);
      }

      if (this.pill) {
        window.addEventListener('scroll', this.requestPillUpdate, { passive: true });
        window.addEventListener('resize', this.requestPillUpdate, { passive: true });
        this.updatePill();
      }
    }

    disconnectedCallback() {
      if (this.select) this.select.removeEventListener('change', this.handleChange);
      window.removeEventListener('scroll', this.requestPillUpdate);
      window.removeEventListener('resize', this.requestPillUpdate);
    }

    handleChange() {
      var page = parseInt(this.select.value, 10);
      var current = parseInt(this.dataset.current, 10);
      if (!page || page === current) return;
      window.location.assign(OmPagination.pageUrl(window.location.href, page, this.dataset.anchor));
    }

    static pageUrl(href, page, anchor) {
      var url = new URL(href);
      if (page <= 1) {
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('page', String(page));
      }
      url.hash = anchor || '';
      return url.toString();
    }

    isMobile() {
      return typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_QUERY).matches;
    }

    requestPillUpdate() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(this.updatePill);
    }

    updatePill() {
      this.ticking = false;
      if (!this.pill || !this.grid || !this.nav) return;

      var show = false;
      if (this.isMobile()) {
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        var gridTop = this.grid.getBoundingClientRect().top;
        var navTop = this.nav.getBoundingClientRect().top;
        show = gridTop < -SCROLLED_INTO_GRID && navTop > viewport;
      }
      this.pill.classList.toggle('is-visible', show);
    }
  }

  customElements.define('om-pagination', OmPagination);
})();
